import { render, staticRenderFns } from "./repel_bird.vue?vue&type=template&id=1850d271&"
import script from "./repel_bird.vue?vue&type=script&lang=js&"
export * from "./repel_bird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports